import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "21",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "2",
      d: "m5 5.5 10 10M15 5.5l-10 10"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      d: "M16.718 17.218a9.5 9.5 0 0 1-13.435 0 9.5 9.5 0 0 1 0-13.435 9.5 9.5 0 0 1 13.435 0 9.5 9.5 0 0 1 0 13.435Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }